export default {"src":"__ASTRO_ASSET_IMAGE__CKJkjJVK__","width":663,"height":678,"format":"png"}